import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
    GET_SESSION_LIST,
    GET_SESSION_DATA
} from "../constants/ActionTypes";

import {
    getSessionListSuccess,
    getSessionListError,
    getSessionDataSuccess,
    getSessionDataError
} from "../actions/SessionAction";
import { userSignOut } from '../actions/Auth'

import { getSessionListApi, getSessionDataApi } from "../api/SessionApi";

function* getSessionListRequest({ payload }) {
    try {
        const sessionList = yield call(getSessionListApi, payload);
        if (sessionList.code) {
            if (sessionList.code === 401) {
                yield put(userSignOut());
            } else {
                yield put(getSessionListError(sessionList));
            }
        } else {
            yield put(getSessionListSuccess(sessionList));
        }
    } catch (error) {
        yield put(getSessionListError(error));
    }
}

function* getSessionDataRequest({ payload }) {
    try {
        const sessionData = yield call(getSessionDataApi, payload);
        if (sessionData.code) {
            yield put(getSessionDataError(sessionData));
        } else {
            yield put(getSessionDataSuccess(sessionData));
        }
    } catch (error) {
        yield put(getSessionDataError(error));
    }
}

export function* getSessionList() {
    yield takeEvery(GET_SESSION_LIST, getSessionListRequest);
}
export function* getSessionData() {
    yield takeEvery(GET_SESSION_DATA, getSessionDataRequest);
}

export default function* rootSaga() {
    yield all([fork(getSessionList),
    fork(getSessionData)
    ]);
}